<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { ticketEmailFragment, ticketEmailStyles } from "@/utils/ticketEmailHtml";

const props = defineProps({ html: { type: String, default: "" } });
const host = ref(null);
let root;
let colourScheme;
let themeObserver;

function syncTheme() {
  host.value?.toggleAttribute("data-dark", Boolean(colourScheme?.matches || document.documentElement.classList.contains("dark")));
}
function renderEmail() {
  if (!root) return;
  const style = document.createElement("style");
  style.textContent = ticketEmailStyles;
  const body = document.createElement("div");
  body.className = "email-body";
  body.append(ticketEmailFragment(props.html));
  root.replaceChildren(style, body);
}
onMounted(() => {
  // Shadow DOM keeps email markup separate from global and Tailwind descendant rules.
  root = host.value.attachShadow({ mode: "open" });
  colourScheme = window.matchMedia("(prefers-color-scheme: dark)");
  colourScheme.addEventListener("change", syncTheme);
  themeObserver = new MutationObserver(syncTheme);
  themeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
  syncTheme();
  renderEmail();
});
watch(() => props.html, renderEmail);
onBeforeUnmount(() => {
  colourScheme?.removeEventListener("change", syncTheme);
  themeObserver?.disconnect();
});
</script>

<template>
  <div ref="host" class="ticket-email-body" />
</template>

<style scoped>
.ticket-email-body { min-width: 0; max-width: 100%; }
</style>
